import Constants from "~/helpers/enums/Constants";

const initialState = {
	bookingTransactionTimes: null,
};

const confirmationReducer = (state = initialState, action = null) => {
	switch (action.type) {
		case Constants.GET_BOOKING_TRANSACTION:
			return {
				...state,
				bookingTransactionTimes: action.payload.bookingTransactionTimes,
			};
		default:
			return state;
	}
};

export default confirmationReducer;
